import Dom from '../../shared/dom';
import { Component } from '../component/component';

export class FancyItem extends Component {

	constructor(name, content, icon, parent) {
		super();
		this.name = name;
		this.content = content;
		this.icon = icon;
		this.node = this.getNode();
		this.open = false;
		this.parent = parent;
		this.addListener();
	}

	getTemplate() {
		let template;
		template = `
        <div class="conf__fancy">
            <div class="conf__fancy-content">
	            <div class="conf__fancy-close"><svg data-info class="ico"><use xlink:href="#ico-close-fancy"></use></svg></div>
                <h4 class="h4">${this.name}</h4>
                <div class="text">${this.content}</div>
				<div class="cta"><a href="#" class="btn btn-primary">Continua configurazione</a></div>
            </div>
        </div>
        `;
		return template;
	}

	addListener() {
		this.close = this.node.querySelector('.conf__fancy-close');
		this.icon.addEventListener('click', this.toggle.bind(this));
		this.close.addEventListener('click', this.toggle.bind(this));
	}

	toggle() {
		if (this.open) {
			this.node.classList.remove("active");
			this.node.style.left = '0';
			this.open = false;
			setTimeout(x => {
				this.node.style.zIndex = '2';
			}, 300);
			if (!this.parent) {
				return;
			}
			this.parent.classList.remove('conf__panel-wrapper--fancy-on');
		} else {
			this.node.style.left = '-100%';
			this.node.style.zIndex = '3';
			this.node.classList.add("active");
			this.open = true;
			if (!this.parent) {
				return;
			}
			this.parent.classList.add('conf__panel-wrapper--fancy-on');
			if (!Dom.mobile) {
				this.node.style.top = this.parent.scrollTop + 'px';
			}
		}
	}
}
